import {P} from '@quarks';
import styled from 'styled-components';

export const StyledParagraph = styled(P)`
  color: ${({theme}) => theme.input.placeholder};
`;
